import styled from "styled-components";

const Form = styled.form`
  padding: 10px;
  margin-top: 10px;
  border-radius: 5px;
  border: none;
  outline: none;
`;

export default Form;